<template>
<div>
  <div class="vl-parent">
        <loading v-model:active="isLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="fullPage"/>
  </div>
  <div class="container mb-0 pt-0 mt-60">
        <div class="section-content">
          <div class="row mt-10">
            <h3 style="background: #ED1C24; padding: 10px; line-height: 42px; text-align: center; color: #fff;">{{this.federationname}}</h3>
              <div class="table-responsive tbox"> 
              <h3 style="text-align:center;">Federation Chairman Information</h3>
              <table class="table table-bordered"> 
                <thead> 
                  <tr> 
                    <th>Name</th> 
                    <th>Phone</th> 
                  </tr> 
                </thead> 
                <tbody> 
                  <tr> 
                    <th scope="row">{{federationchairman.NameofCurrentFederationChairman}}</th> 
                    <th scope="row">{{federationchairman.  MobilenumberofCurrentFederationChairman }}</th> 
                  </tr> 
                </tbody> 
              </table> 
            </div>

        <div class="table-responsive tbox"> 

            <h3 style="text-align:center;"> Committee Member</h3>
      <table class="table table-bordered"> 
                <thead> 
                  <tr> 
                    <th>Name</th> 
                    <th>Phone</th> 
                    <th>Gender</th> 
                    <th>Designation</th> 
                  </tr> 
                </thead> 
                <tbody> 
              <tr v-for="member in committeembers" :key="member.id">
                <td>{{ member.name }}</td>
                <td>{{ member.phone }}</td>
                <td>{{ member.gender }}</td>
                <td>{{ member.designation }}</td>
              </tr>
                </tbody> 
              </table> 
          </div>

              <div class="table-responsive tbox"> 
              <h3 style="text-align:center;">Federation Registration Information</h3>
              <table class="table table-bordered"> 
                <thead> 
                  <tr> 
                    <th>Registration Number</th> 
                    <th>Registration Received from (DSS/DYD /DC/DWA)*</th> 
                  </tr> 
                </thead> 
                <tbody> 
                  <tr> 
                    <th scope="row">{{registrationinformation.RegistrationNumber}}</th> 
                    <td>{{registrationinformation.RegistrationReceivedfrom}}</td> 
                  </tr> 
                </tbody> 
              </table> 
            </div>

             

          

            <div class="table-responsive tbox"> 
              <h3 style="text-align:center;">General Information</h3>
              <table class="table table-bordered"> 
                <thead> 
                  <tr> 
                    <th>Grade And Present</th> 
                  </tr> 
                </thead> 
                <tbody> 
                  <tr> 
                    <th scope="row">{{this.grade_and_present}}</th> 
                  </tr> 
                </tbody> 
              </table> 
            </div>

           
            <div class="table-responsive tbox">   
              <h3 style="text-align:center;">Information on Organizational Structure </h3>
              <h4>Federation Group Information</h4>
              <table class="table table-bordered"> 
                <thead> 
                  <tr> 
                    <th>Male Group</th> 
                    <th>Female Group</th> 
                    <th>Total</th>                   
                  </tr> 
                </thead> 
                <tbody> 
                  <tr> 
                    <th scope="row">{{federationgroupinformation.Male_Group}}</th> 
                    <td>{{federationgroupinformation.Female_Group}}</td> 
                    <td>{{federationgroupinformation.Total}}</td> 
                  </tr> 
                </tbody> 
              </table>
              <h4>Federation General Member</h4>
              <table class="table table-bordered"> 
                <thead> 
                  <tr> 
                    <th>Male</th> 
                    <th>Female</th> 
                    <th>Total</th>       
                    <th>Excluded Members</th>                   
                  </tr> 
                </thead> 
                <tbody> 
                  <tr> 
                    <th scope="row">{{federationgeneralmember.Male}}</th> 
                    <td>{{federationgeneralmember.Female}}</td> 
                    <td>{{federationgeneralmember.Total}}</td> 
                    <td>{{federationgeneralmember.Excluded_Members}}</td> 
                  </tr> 
                </tbody> 
              </table> 
            </div>
            <div class="table-responsive tbox"> 
              <h3 style="text-align: center;">Information on Federation Different Committee and Wings</h3>
              <h4 style="text-align: center;">General Committee Member</h4>
              <table class="table table-bordered"> 
                <thead> 
                  <tr> 
                    <th>Male</th> 
                    <th>Female</th> 
                    <th>Total</th> 
                  </tr> 
                </thead> 
                <tbody> 
                  <tr> 
                    <th scope="row">{{generalcommitteemember.Male}}</th> 
                    <td>{{generalcommitteemember.Female}}</td> 
                    <td>{{generalcommitteemember.Total}}</td>   
                  </tr> 
                </tbody> 
              </table> 
              <h4 style="text-align:center;">Executive Committee Member</h4>
              <table class="table table-bordered"> 
                <thead> 
                  <tr> 
                    <th>Male</th> 
                    <th>Female</th> 
                    <th>Total</th> 
                  </tr> 
                </thead> 
                <tbody> 
                  <tr> 
                    <th scope="row">{{executivecommitteemember.Male}}</th> 
                    <td>{{executivecommitteemember.Female}}</td> 
                    <td>{{executivecommitteemember.Total}}</td> 
                  </tr> 
                </tbody> 
              </table> 

              

            </div>
            <div class="table-responsive tbox">
             <h3>Information on Social Forestry Program</h3> 
           <table class="table table-bordered">
               <thead>
              <tr> 
              <th>Number trees survived which age 3 or above 3 years  </th> 
            <th>Number of trees sold during the reporting period</th> 
              <th>Amount received by selling trees during the reporting period (Tk)</th>
                <th>Where the tree selling amount deposited (Federation Bank Account/Cash in Hand)</th> 
           </tr> 
           </thead> 
           <tbody> 
               <tr v-if="isfprograms"> 
               <th scope="row">{{ isfprograms.number_age_above_three }}</th>
                 <td>{{ isfprograms.number_of_three_reporting_period }}</td> 
                <td>{{ isfprograms.amoun_recive_by_selling_trees }}</td> 
                <td>{{  isfprograms.federation_bank_account}}</td> 
                    
                 </tr> 
            </tbody> 
             </table> 
          </div>
           <div class="table-responsive tbox"> 
            <h3>Federation members are in SSN and MF Program</h3>
            <table class="table table-bordered"> 
              <thead> 
                <tr>
                  <th>Federation members are in Social Safety Net Program</th> 
                 <th>Federation members are in Micro Finance Program</th> 
                    
                 </tr> 
           </thead> 
              <tbody> 
               <tr  v-if="fmssnprograms"> 
                 <th scope="row">{{ fmssnprograms.social_safety_net_program }}</th> 
                <td>{{ fmssnprograms.micro_finance_program }}</td>  
              </tr> 
               </tbody> 
            </table> 
           </div>
            
          </div>
        </div>
     </div>
  </div>
</template>
<script>
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
export default{
 	props:['federationid'],
    components: {
    Loading
    },
	data(){
			return{
				searchproduct:'',
			    federationlist:[],
			    federationok:false,
			    suggestion:false,
			    federation:'',
				registrationinformation:[],
				federationgroupinformation:[],
				federationgeneralmember:[],
        generalcommitteemember:[],
        isfprograms:[],
        federationchairman:[],
        fmssnprograms:[],
        executivecommitteemember:[],
        committeembers:[],
        grade_and_present:'',
        federationname:'',
        fedrid:0,
        isLoading: false,
        fullPage: true
			}
	 },
   created(){
     this.getfederationdetails();
     document.addEventListener('click', this.pageClick);
   },
	 mounted(){
	 	
	 	
	 },
	 beforeUnmount() {
      document.removeEventListener('click', this.pageClick);
     },
     computed:{
      url(){
      return this.$store.state.url;
      }
   
     },
	 methods:{
	  searchfederation(){
      this.isLoading = true;
      if(this.federation==''){
        toast.warning("Please insert a federation name", {
        autoClose: 1000,
        transition:'zoom',
        position:'top-center'
        });
        this.isLoading = false;
      }else{
        axios.post(this.url+'searchfederationdetails',{
          federationid:this.fedrid,
        }).then(response=>{

          console.log(response.data);

           setTimeout(() => {
           this.isLoading = false;
           this.registrationinformation=response.data.registrationinformation;
           this.federationgroupinformation=response.data.federationgroupinformation;
           this.isfprograms=response.data.isfprograms;
           this.fmssnprograms=response.data.fmssnprograms;
           this.federationgeneralmember=response.data.federationgeneralmember;
           this.generalcommitteemember=response.data.generalcommitteemember;
           this.executivecommitteemember =response.data.executivecommitteemember;
           this.federationname=response.data.federationname;
           this.federationchairman=response.data.federationchairman;
           this.committeembers=response.data.committeembers;
        
         

           // this.federation='';

           },1000)


        })

      } 
      },
	  pageClick(event){
      if (
           event.target !== this.$refs.inputField &&
           event.target !== this.$refs.suggestionsList
           ) {
            this.federationok = false;
            this.suggestion=false;

       }
     },
     searchInput(event){
      var federationname=event.target.value;
      if(federationname==''){
      this.federationlist=[];
      }else{
        axios.get(this.url+'getfederationlist/'+federationname).then(response=>{
                this.federationlist=response.data;
         console.log(this.federationlist);
        })
        this.federationok=true;

      }

    },
	selectfederation(federation){

	      this.federation=federation.FederationName;
	      this.fedrid=federation.id;
	      console.log(this.fedrid);

	   },
     

       getfederationdetails(){

           axios.get(this.url+'getfederationdetails/'+this.federationid).then(response=>{
                console.log(response.data);
                this.registrationinformation=response.data.registrationinformation;
                this.federationgroupinformation=response.data.federationgroupinformation;
                this.federationgeneralmember=response.data.federationgeneralmember;
                this.isfprograms=response.data.isfprograms;
                this.fmssnprograms=response.data.fmssnprograms;
                this.generalcommitteemember=response.data.generalcommitteemember;
                this.executivecommitteemember =response.data.executivecommitteemember;
                this.federationname=response.data.federationname;
                this.grade_and_present=response.data.grade_and_present;
                this.federationchairman=response.data.federationchairman;
                this.committeembers=response.data.committeembers;
             
              
           })
       }


	 }
 }

</script>
<style scoped>
 .productlist
  {
    position: absolute;
    background: #333;
    color: white;
    width: 100%;
    z-index: 999999;
  }
  .productlist ul{
    list-style: none;
    background: rgb(237, 28, 36);
  }
  .productlist ul li{
    border-bottom: 1px solid white;
    padding:5px;
    cursor: pointer;
  }

  .pre-loader {
  padding: 10px;
  background-color: #f1f1f1;
  /* Add more styles as needed */
  }
  </style>